<div>
  <div class="modal-content">
    <div class="modal-header">
        <div class="col-lg-12" style="width:100%">
          <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button>
        </div>

        <div class="col-lg-6" style="width:50%">
          <h3 class="modalHeader" style="color:#666;">
            <i class="fa fa-check" aria-hidden="true" style="color:green;"></i> Processed Files {{ProCount}}</h3>
        </div>
        <div class="col-lg-6" style="width:50%">
          <h3 class="modalHeader" style="color:#666;">
            <i class="fa fa-remove" aria-hidden="true" style="color:red;"></i>Error Files {{ErrorCount}}</h3>
        </div>
      
    </div>

    <div class="modal-body" style="display:inline-block;width:100%;" >

      <div class="col-lg-6" style="width:50%">
        <!-- <h3 class="modalHeader" style="color:#666;">
          <i class="fa fa-check" aria-hidden="true" style="color:green;"></i> Processed Files</h3>
        <hr> -->
                
        <div *ngFor= "let item of result1['processedFiles']" >

          <p>
              <span>
                <!-- <img src="./assets/static/icon-xl.png" width=20 height=18 />&nbsp;&nbsp; -->
                <i class="fa fa-file-excel-o" style="color:rgb(27, 184, 27);" aria-hidden="true"></i>&nbsp;
              </span>{{item}}            
          </p>

        </div>
      </div>

      <div class="col-lg-6" style="width:50%">
        <!-- <h3 class="modalHeader" style="color:#666;">
          <i class="fa fa-remove" aria-hidden="true" style="color:red;"></i> Error Files</h3>
        <hr> -->
        <div  *ngFor= "let item of result1['errorFiles']" >
          
          <p>
            <span>
            <!-- <img src="./assets/static/icon-xl.png"  width=20 height=18 />&nbsp;&nbsp; -->
              <i class="fa fa-file-excel-o" style="color:red;"  aria-hidden="true"></i>&nbsp;             
            </span>{{item}}
          </p>

        </div>
      </div>
      
    </div>

  </div>
</div>
    